/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { N20A } from '@atlaskit/theme/colors';
var placeholderContainerStyles = null;
var reactButtonStyles = null;
var replyButtonStyles = null;
export var ReactReplyBarPlaceholder = function ReactReplyBarPlaceholder() {
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "react-reply-bar-placeholder",
    className: ax(["_1e0c1txw _2lx2vrvc _4cvr1h6o _80om1x0y _19pkv77o _otyrv77o _18u0idpf"])
  }, /*#__PURE__*/React.createElement("span", {
    "data-testid": "react-button",
    className: ax(["_2rko1y44 _1bsbzwfg _4t3i1tcg _bfhk7npx _2hwxu2gc"]),
    style: {
      "--_1e0jrce": ix("var(--ds-skeleton-subtle, ".concat(N20A, ")"))
    }
  }), /*#__PURE__*/React.createElement("span", {
    "data-testid": "reply-button",
    className: ax(["_2rko1y44 _1bsb3okq _4t3i1tcg _bfhk7npx"]),
    style: {
      "--_1e0jrce": ix("var(--ds-skeleton-subtle, ".concat(N20A, ")"))
    }
  }));
};